import { render, staticRenderFns } from "./CallPartnerTariffZone.vue?vue&type=template&id=77e363ec&"
import script from "./CallPartnerTariffZone.vue?vue&type=script&lang=ts&"
export * from "./CallPartnerTariffZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports